// AdminGeneralSettings.jsx
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Stack,
  TextField,
} from "@mui/material";
import {
  fetchAllNotificationSettings,
  saveSettings,
} from "../../Controllers/notificationController";
import { useError } from "../../Context/errorContext";

const AdminNotifications = () => {
  const [notificationSetting, setNotificationSetting] = useState(null);
  const { setAlert } = useError();
  useEffect(() => {
    fetchAllNotificationSettings(setNotificationSetting);
  }, []);

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            disabled={notificationSetting?.active ?? false}
            checked={notificationSetting?.active ?? false}
            onChange={(event, checked) => {
              const newSetting = { ...notificationSetting };
              newSetting.active = checked;
              saveSettings(newSetting, setAlert);
              setNotificationSetting(newSetting);
            }}
          />
        }
        label="Setting is active"
        sx={{
          // make the label span only hug its text
          "& .MuiFormControlLabel-label": {
            cursor: "pointer",
            width: "auto",
          },
          width: "fit-content", // collapse whole thing
        }}
      />
      <Typography mb={2} variant="h6">
        Send e-mail notifictations to the following roles
      </Typography>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.accountants ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.accountants = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Accountants"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.unit_managers ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.unit_managers = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Unit Managers"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.project_managers ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.project_managers = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Project Managers"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.project_members ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.project_members = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Project Members"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <Typography mb={2} variant="h6">
          Project review notifications
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={
                notificationSetting?.notify_on_unit_manager_approval ?? false
              }
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.notify_on_unit_manager_approval = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Notify project manager when unit manager approves the project"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <Typography mb={2} variant="h6">
          Project Progress settings
        </Typography>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
          }}
        >
          <Typography mr={2}>Progress locked at day of month</Typography>
          <TextField
            type="number"
            value={
              notificationSetting?.project_progress_locked_at_day_of_month ?? 0
            }
            onChange={(e) => {
              const newSetting = { ...notificationSetting };
              newSetting.project_progress_locked_at_day_of_month =
                e.target.value;
              //saveSettings(newSetting, setAlert);
              setNotificationSetting(newSetting);
            }}
            onBlur={(e) => {
              saveSettings(notificationSetting, setAlert);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
            sx={{
              // make the label span only hug its text
              "& .MuiFormControlLabel-label": {
                cursor: "pointer",
                width: "auto",
              },
              width: "100px", // collapse whole thing
            }}
          />
        </Stack>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
          }}
        >
          <Typography mr={2}>
            Progress notification to PM at day of month
          </Typography>
          <TextField
            type="number"
            value={
              notificationSetting?.project_progress_notify_at_day_of_month ?? 0
            }
            onChange={(e) => {
              const newSetting = { ...notificationSetting };
              newSetting.project_progress_notify_at_day_of_month =
                e.target.value;
              //saveSettings(newSetting, setAlert);
              setNotificationSetting(newSetting);
            }}
            onBlur={(e) => {
              saveSettings(notificationSetting, setAlert);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
            sx={{
              // make the label span only hug its text
              "& .MuiFormControlLabel-label": {
                cursor: "pointer",
                width: "auto",
              },
              width: "100px", // collapse whole thing
            }}
          />
        </Stack>
        <Typography mb={2} variant="h6">
          My Hours
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.sync_to_my_hours ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.sync_to_my_hours = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Sync to My Hours on Project Save/Confirmation/Code update"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
        <Typography mb={2} variant="h6">
          Joosep
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.sync_to_joosep ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.sync_to_joosep = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Sync to Joosep on Project Confirmation/Code update"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />

        <Typography mb={2} variant="h6">
          TimeEdit
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={notificationSetting?.sync_to_timeedit ?? false}
              onChange={(event, checked) => {
                const newSetting = { ...notificationSetting };
                newSetting.sync_to_timeedit = checked;
                saveSettings(newSetting, setAlert);
                setNotificationSetting(newSetting);
              }}
            />
          }
          label="Sync to TimeEdit on Project Confirmation"
          sx={{
            // make the label span only hug its text
            "& .MuiFormControlLabel-label": {
              cursor: "pointer",
              width: "auto",
            },
            width: "fit-content", // collapse whole thing
          }}
        />
      </Stack>
    </Box>
  );
};

export default AdminNotifications;
